import { useIntl } from "react-intl";

interface IBudgetCreateActionProps {
  submitting?: boolean;
  disabled?: boolean;
  onCreate: () => Promise<void> | void;
}

export const BudgetCreateAction = (props: IBudgetCreateActionProps) => {
  const intl = useIntl();
  const { submitting, disabled, onCreate } = props;

  return (
    <div className="mb-6 px-6">
      <div className="flex flex-row justify-end mt-10">
        <button
          type="button"
          className="w-[250px] bg-teal-500 text-white rounded-md hover:bg-teal-600 px-6 py-2 text-size-15 font-bold disabled:opacity-50"
          onClick={onCreate}
          disabled={submitting || disabled}
        >
          {intl.formatMessage({ id: "intl-msg:budgets.sendBudget" })}
        </button>
      </div>
    </div>
  );
};
